export default __webpack_public_path__ + "static/media/iic 4.a7e9bd05.JPG";